import { createI18n } from 'vue-i18n'
import { localStorageKey, defaultLang, getlocalStorageLang } from '@/i18n/langType'
import { jaMsg, enMsg, zhMsg } from './lang'

// i18nのデータ
const i18n = createI18n({
  locale: getlocalStorageLang(), // デフォルトはlocalStorageから取得した言語
  fallbackLocale: defaultLang, // 設定ファイルが無い場合はデフォルト言語
  messages: {
    ja: jaMsg,
    en: enMsg,
    zh: zhMsg,
  },
})

export {
  i18n, // i18n
  localStorageKey, // ローカルストレージキー
  getlocalStorageLang, // ローカルストレージから言語取得
}
